import React, { useEffect, useState } from "react";
import "./NewDashboard.scss";
import { ReactComponent as Star } from "../../../assets/Affiliate/start.svg";
import { ReactComponent as FourStar } from "../../../assets/Affiliate/superStart.svg";
import { ReactComponent as InfoIcon } from "../../../assets/icons/UpdatedCheckoutPage/InfoIcon.svg";
import ClickStatsChart from "../Dashhboard/ClickStatsChart";
import CandleChart from "./CandleChart";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { baseUrl } from "../../../Axios";
import ReferList from "./ReferList";
import dayjs from "dayjs";
import { FormatUSD } from "../../../utilities/string";
import Loader from "../../../reusableComponents/Loader";
import moment from "moment";
import { ConfigProvider, DatePicker, Space, Tooltip } from "antd";
import { requestPayout } from "../../../store/reducers/payoutReducer";
import toast from "react-hot-toast";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check-full-green.svg";
const { RangePicker } = DatePicker;

const AffiliateDashboard = () => {
  const { ACCtoken } = useSelector((state) => state);
  const [overviewData, setOverviewData] = useState();
  const [activeTier, setActiveTier] = useState();
  const [revenueData, setRevenueData] = useState();
  const [loading, setLoading] = useState(false);
  const [paramsValue, setParamsValue] = useState({});
  const [bonusLoading, setBonusLoading] = useState(false);
  const fetchAffiliateOverview = async () => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: ACCtoken,
      },
      params:
        paramsValue?.start_date && paramsValue?.end_date
          ? {
              start_date: moment(paramsValue.start_date).format("DD/MMM/YYYY"),
              end_date: moment(paramsValue.end_date).format("DD/MMM/YYYY"),
            }
          : {},
    };
    try {
      const response = await axios.get(
        `${baseUrl}/affiliate/v2/dashboard/`,
        config
      );

      console.log(response.data); // Properly logging the response data
      setOverviewData(response?.data);

      // Set active tier based on Tier property
      const tiers = response.data?.AFFILIATE_TIER;
      const selectedTier =
        tiers?.find((tier) => tier.name === response.data.Tier) || tiers[0];
      setActiveTier(selectedTier);
    } catch (error) {
      console.error("Error fetching affiliate overview:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRevenueAndCommission = async () => {
    const config = {
      headers: {
        Authorization: ACCtoken,
      },
      params:
        paramsValue?.start_date && paramsValue?.end_date
          ? {
              start_date: moment(paramsValue.start_date).format("YYYY-MM-DD"),
              end_date: moment(paramsValue.end_date).format("YYYY-MM-DD"),
            }
          : {},
    };
    try {
      const revenueResponse = await axios.get(
        `${baseUrl}/affiliate/v2/commission-vs-revenue/`,
        config
      );
      setRevenueData(revenueResponse.data);
    } catch (error) {
      console.error("Error fetching revenue data:", error);
    }
  };
  useEffect(() => {
    fetchRevenueAndCommission();
  }, [paramsValue]);

  useEffect(() => {
    if (ACCtoken) {
      fetchAffiliateOverview();
    }
  }, [ACCtoken, paramsValue]);

  const getStars = (tier) => {
    if (tier === 1) {
      return <Star />;
    } else if (tier === 2) {
      return (
        <>
          <Star />
          <Star />
        </>
      );
    } else if (tier === 3) {
      return (
        <>
          <Star />
          <Star />
          <Star />
        </>
      );
    } else {
      return <FourStar />;
    }
  };

  // Calculate conversions needed for next tier
  const getConversionsNeeded = () => {
    if (!activeTier || !overviewData) return "N/A";
    const uniqueCount = overviewData.unique_count;
    const tiers = overviewData.AFFILIATE_TIER;
    const currentTierIndex = tiers.findIndex(
      (tier) => tier.tier === activeTier.tier
    );
    if (currentTierIndex === tiers.length - 1) {
      return "Max tier reached";
    }
    const nextTier = tiers[currentTierIndex + 1];
    const conversionsNeeded =
      nextTier?.unique_customer_range &&
      nextTier?.unique_customer_range[0] - uniqueCount;
    return conversionsNeeded > 0
      ? `${conversionsNeeded} more successful conversions`
      : "Eligible for next tier";
  };
  const dispatch = useDispatch();
  const handleGetbonus = async () => {
    if (bonusLoading) return;
    setBonusLoading(true);
    const payload = {
      amount: overviewData?.bonus_amount,
      type: "Bonus",
    };
    try {
      const response = await dispatch(requestPayout(payload));
      toast.success("Bonus payout requested successfully!");
    } catch (err) {
      toast.error(
        err.detail || "Failed to request bonus payout. Please try again."
      );
    } finally {
      setBonusLoading(false);
    }
  };

  const affiliateTiersInfo = [
    {
      milestoneBonus: (
        <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
          <span>1. Private community access at 25 unique referrals</span>
          <span>2. $200 + 1x $10k account giveaway at 50 unique referrals</span>
          <span>3. 3x 10k account giveaway at 70 unique referrals</span>
        </div>
      ),

      payouts: "Biweekly",
      requirements:
        "Minimum 10 referrals before first withdrawal, Minimum withdrawal $100",
      commission: "6%",
    },
    {
      reward: "$1,250 bonus for reaching Tier 2",

      milestoneBonus: "$400 at 200 unique referrals",
      monthlyGiveaways: "1x $25,000 + 5x $5,000 accounts",
      affiliateAccounts:
        "$25k account + Entry into $50,000 account giveaway with other Alpha Captains",
      "Support &Perks":
        "Priority support, Private community access, Merch giveaways, Early platform access",
      payouts: "Weekly withdrawals",
      requirements: "Minimum withdrawal $100",
      commission: "8%",
    },
    {
      reward: "$3,000 bonus for reaching Tier 3",

      milestoneBonus: "$700 at 500 unique referrals",
      monthlyGiveaways: "2x $50k + 5x $10k accounts",
      affiliateAccounts:
        "$100k account + Entry into cash giveaway with other Alpha Majors",
      "Support &Perks":
        "Priority support, VIP events, Early platform access, Merch giveaways, Private community access",
      payouts: "Withdraw anytime",
      requirements: "Minimum withdrawal $100",
      commission: "9%",
    },
  ];

  return (
    <div className="newDashboard">
      {<Loader open={loading} />}
      <div className="date-range">
        <RangePicker
          onChange={(dates) => {
            if (dates) {
              setParamsValue({
                start_date: dates[0].format("YYYY-MM-DD"),
                end_date: dates[1].format("YYYY-MM-DD"),
              });
            } else {
              setParamsValue({});
            }
          }}
        />
      </div>
      <div className="date-range date">
        <p>Next withdrawal Date : {overviewData?.next_withdrawal_date}</p>
      </div>

      <div className="affiliate-tiers">
        {overviewData?.AFFILIATE_TIER?.map((item, index) => (
          <div
            key={item.tier}
            className={`affiliate-tier ${
              item.name === overviewData?.Tier ? "active" : ""
            }`}
          >
            <div className="stars">{getStars(item.tier)}</div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                marginLeft: index !== 3 && "21px",
              }}
            >
              <div className="title">Tier {item.tier}</div>
              {index !== 3 && (
                <ConfigProvider
                  theme={{
                    components: {
                      Tooltip: {
                        zIndexPopup: 1,
                      },
                    },
                  }}
                >
                  <Tooltip
                    title={
                      <>
                        {Object.entries(affiliateTiersInfo[index] || {}).map(
                          ([key, value]) => (
                            <div className="othersBenefits" key={key}>
                              <span className="label">
                                {key
                                  .replace(/([A-Z])/g, " $1")
                                  .replace(/^./, (str) => str.toUpperCase())}
                                :
                              </span>
                              <span>{value}</span>
                            </div>
                          )
                        )}
                      </>
                    }
                  >
                    <div style={{ cursor: "pointer" }}>
                      <InfoIcon />
                    </div>
                  </Tooltip>
                </ConfigProvider>
              )}
            </div>
            <p className="heading-name">{item.name}</p>
            <p className="range">
              {item.name === "Super Affiliate"
                ? ""
                : `(${item.unique_customer_range[0]}${
                    item.unique_customer_range[1] === "+"
                      ? "+"
                      : `-${item.unique_customer_range[1]}`
                  } Unique Customers)`}
            </p>
          </div>
        ))}
      </div>
      {overviewData?.Tier !== "Super Affiliate" && (
        <div className="affiliate-overview">
          {overviewData?.bonus && (
            <button
              type="button"
              onClick={handleGetbonus}
              className="get-bonus bonus-check"
              disabled={!overviewData?.bonus || bonusLoading}
              aria-disabled={!overviewData?.bonus || bonusLoading}
            >
              {bonusLoading ? (
                <span className="spinner" aria-label="Loading"></span>
              ) : (
                <>
                  <span className="bonus-check-icon">
                    <CheckIcon />
                  </span>
                  <span className="bonus-check-text">Claim Bonus</span>
                  {overviewData?.bonus_amount && (
                    <span className="bonus-check-amount">
                      {FormatUSD(overviewData.bonus_amount)}
                    </span>
                  )}
                </>
              )}
            </button>
          )}
          <div
            className="overview-heading"
            style={{ margin: !overviewData?.bonus && "auto" }}
          >
            <span>
              To reach
              <span className="active">
                Tier {activeTier?.tier + 1 || "N/A"}
              </span>
              you need:
            </span>
            <span>{getConversionsNeeded()}</span>
          </div>
          {/* <div className="bonus-box">
            <div className="box">
              <div>
                <span>Commission:</span>
                <span>
                  {activeTier?.commission_percentage}% on all purchases
                </span>
              </div>
              {activeTier?.other_benefits
                ?.filter(
                  (benefit) =>
                    benefit.includes("Bonus") ||
                    benefit.includes("Milestone Coupons")
                )
                .map((benefit, index) => (
                  <div key={index}>
                    <span>
                      {benefit.includes("Milestone Coupons")
                        ? "Milestone Coupons"
                        : "Bonus"}
                      :
                    </span>
                    <span>{benefit.split(": ")[1] || benefit}</span>
                  </div>
                ))}
            </div>
            <div className="box">
              {activeTier?.other_benefits
                ?.filter(
                  (benefit) =>
                    benefit.includes("Giveaway") ||
                    benefit.includes("Payouts") ||
                    benefit.includes("Requirement") ||
                    benefit.includes("Accounts")
                )
                .map((benefit, index) => (
                  <div key={index}>
                    <span>
                      {benefit.includes("Giveaway")
                        ? "Giveaway"
                        : benefit.includes("Payouts")
                        ? "Payouts"
                        : benefit.includes("Requirement")
                        ? "Requirement"
                        : "Accounts"}
                      :
                    </span>
                    <span>{benefit.split(": ")[1] || benefit}</span>
                  </div>
                ))}
            </div>
          </div>
          <div className="bottom-desc">
            {activeTier?.other_benefits?.find((benefit) =>
              benefit.includes("Private Community Access")
            ) ||
              "Private Community Access (connect with other top affiliates for strategy sharing) 25+ UNIQUE referrals"}
          </div> */}
        </div>
      )}
      <div className="stats">
        <div className="stats-box">
          <p>Total Signup's</p>
          <p>{overviewData?.signups}</p>
        </div>
        <div className="stats-box">
          <p
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            Total Conversions
          </p>
          <p>{overviewData?.conversions}</p>
        </div>
        <div className="stats-box">
          <p>Unique Count</p>
          <p>{overviewData?.unique_count}</p>
        </div>
        <div className="stats-box">
          <p>Total Revenue Generated</p>
          <p>{FormatUSD(overviewData?.revenue)}</p>
        </div>
        <div className="stats-box">
          <p
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            Total Commission Earned
          </p>
          <p>{FormatUSD(overviewData?.commission_amount)}</p>
        </div>
        <div className="stats-box">
          <p>Till date outstanding commission</p>
          <p>{FormatUSD(overviewData?.outstanding_commission)}</p>
        </div>
        <div className="stats-box">
          <p>Your Affiliate Code Discount</p>
          <p>
            {overviewData?.months_discount_percentage
              ? overviewData?.months_discount_percentage + "%"
              : FormatUSD(overviewData?.months_discount)}
          </p>
        </div>
      </div>
      <div className="chart">
        <ClickStatsChart data={overviewData?.click_stats} />
        <CandleChart data={revenueData} />
      </div>
      <ReferList param={paramsValue} />
    </div>
  );
};

export default AffiliateDashboard;
